enum TicketColumns {
    Ticket = "Ticket",
    Reporter = "Reporter",
    Assignee = "Assignee",
    CSAssignee = "CSAssignee",
    Title = "Title"
}

export default TicketColumns;